import myAxios from "@/utils/request";
export default {
  // 活动信息管理
  getMessageList(params) {
    return myAxios.post("/api/news/bacactpaging", params);
  },
  batchMessageDelete(params) {
    return myAxios.post("/api/news/batchdeleteact", params);
  },
  // 活动取消
  cancelMessage(params) {
    return myAxios.post("/api/news/cancelactivity", params);
  },
  getCancelReason(params) {
    const { id } = params;
    return myAxios.get("/api/news/getcancelreason?id=" + id);
  },
  // 添加/修改活动详情
  addMessage(params) {
    return myAxios.post("/api/news/addormodifyact", params);
  },
  // 获取活动详细信息
  getMessageInfo(params) {
    const { id } = params;
    return myAxios.get("/api/news/getactivityinfo?id=" + id);
  },

  // 活动参加单位管理
  getCompanyList(params) {
    return myAxios.post("/api/news/getbakcompaging", params);
  },
  batchCompanyDelete(params) {
    return myAxios.post("/api/news/delactcompany", params);
  },
  // 添加/修改单位
  addCompany(params) {
    return myAxios.post("/api/news/addoreditactcompany", params);
  },
  // 获取单位详细信息
  getCompanyInfo(params) {
    return myAxios.post("/api/news/actcompanyinfo", params);
  },

  // 活动报名管理
  getApplyList(params) {
    return myAxios.post("/api/news/actjoinp", params);
  },
  batchApplyDelete(params) {
    return myAxios.post("/api/news/delactjoin", params);
  },
  downLoadApplyList(params) {
    return myAxios.post("/api/news/excelsaveas", params);
  },

  // 新闻信息管理
  getNewsList(params) {
    return myAxios.post("/api/news/newspaging", params);
  },
  batchNewsDelete(params) {
    return myAxios.post("/api/news/batchdeletenews", params);
  },
  // 添加/修改活动详情
  addNews(params) {
    return myAxios.post("/api/news/addoreditnews", params);
  },
  // 获取新闻详细信息
  getNewsInfo(params) {
    const { id } = params;
    return myAxios.get("/api/news/getnewsinfo?id=" + id);
  }
};
